import React, { Component } from 'react';

import get from 'lodash/get';
import map from 'lodash/map';
import range from 'lodash/range';
import find from 'lodash/find';
import includes from 'lodash/includes';
import lowerCase from 'lodash/lowerCase';
import Input from 'ui/Input';
import Text from 'ui/Text';
import Checkboxes from 'ui/Checkboxes';
import SelectItem from 'ui/Select';
import Button from 'ui/Button';
import Auth from 'shared/Auth';
import { FormattedMessage } from 'react-intl';
import AutosuggestInput from 'ui/Autosuggest';

class FieldProcessor extends Component {
  constructor() {
    super();

    this.state = {
      selectValue: '',
      mandatoryText: 'Please answer',
      addBtn: 'Add Row',
      scrollMessage: 'Scroll right to view more content.',
      selectionText: {
        start: 'Select up to ',
        end: 'domaines',
      },
    };
  }

  componentDidMount() {
    if (get(Auth.getLanguage(), 'local_locale') === 'fr') {
      this.setState({
        mandatoryText: 'Veuillez- répondre',
        addBtn: 'Insérer une ligne',
        scrollMessage: 'Faites défiler vers la droite pour afficher plus de contenu.',
        selectionText: {
          start: 'Veuillez sélectionner maximum ',
          end: 'domaines',
        },
      });
    }
  }

  processQuestion = (questionDef, titleKey, valueKey, addRow, newRowValue) => {
    let baseQuestion = questionDef.map((questionItem, index) => (
      <div key={index}>
        <Text modifiers="question-list__item__question">{get(questionItem, titleKey)}</Text>
        {
          <FieldProcessor
            titleKey={titleKey}
            valueKey={valueKey}
            question={questionItem}
            key={index}
            responses={this.props.responses}
            form={this.props.form}
            addRow={addRow}
            newRowValue={newRowValue}
          />
        }
      </div>
    ));

    return baseQuestion;
  };

  mapControlTypes = (field, index, options = [], response = '', titleKey, valueKey, inputKey) => {
    let fieldType;
    const { form } = this.props;
    const { control, type, choices, question_id, id, max_length, data_source } = field;
    const { getFieldDecorator, getFieldError, getFieldValue } = form;
    // let modifiedValue = `${id}__${value}__${sanitizedControl}`;

    switch (control) {
      case 'input':
        let sanitizedChoices = choices.map(choice => {
          return {
            label: get(choice, titleKey),
            value: get(choice, titleKey),
          };
        });

        if (get(field, 'data_source')) {
          return (fieldType = (
            <div>
              {getFieldDecorator(
                inputKey,
                {}
              )(<AutosuggestInput response={response} data_source={'donor_list'} />)}
            </div>
          ));
        }

        type === 'dropdown'
          ? (fieldType = (
              <SelectItem response={response.toString()} items={sanitizedChoices} key={index} />
            ))
          : (fieldType = (
              <div key={index}>
                <Input
                  itemValue={field[valueKey]}
                  options={choices || []}
                  title={field[titleKey] || field[valueKey]}
                  key={index}
                  fieldId={id}
                  nameVal={question_id}
                  nature={type}
                  maxLength={max_length}
                  response={response}
                />
              </div>
            ));
        break;
      case 'date':
        fieldType = <SelectItem items={options} />;
        break;
      case 'extended_date':
        fieldType = <SelectItem items={options} />;
        break;
      default:
        break;
    }

    return fieldType;
  };

  render() {
    const { question, form, responses, titleKey, valueKey, newRowValue, addRow } = this.props;

    const { getFieldDecorator, getFieldError, getFieldValue } = form;

    const { fields, is_mandatory, rules, additional_field, id } = question;

    const specialFieldsType =
      get(find(fields, ['type', 'checkbox']), 'type', '') ||
      get(find(fields, ['type', 'radio']), 'type', '') ||
      get(find(fields, ['type', 'date']), 'type', '') ||
      get(find(fields, ['type', 'extended_date']), 'type', '') ||
      get(find(fields, ['data_source', 'authorisation_body_list']), 'data_source', '') ||
      get(find(fields, ['data_source', 'donor_list']), 'data_source', '') ||
      get(find(fields, ['type', 'table']), 'type', '');

    let specialFields, currentKey, defaultValue, valueTriggered, valueInResponse, mandatoryText;

    currentKey = id;

    switch (specialFieldsType) {
      case 'checkbox':
        let options = fields.map(fieldDef => {
          return {
            label: get(fieldDef, titleKey, '') || get(fieldDef, valueKey, ''),
            value: get(fieldDef, valueKey, ''),
          };
        });

        let finalDef = {
          type: 'array',
          required: is_mandatory,
          message: 'You have to select an option.',
        };

        let ruleDefs = rules.map(ruleDef => {
          let sanitizedKey = get(ruleDef, 'key', '');

          let selectionValue = get(ruleDef, 'value', '');

          if (sanitizedKey === 'minimum_selection') {
            finalDef = {
              ...finalDef,
              min: Number(selectionValue),
              message: `Select at least ${selectionValue} options.`,
            };

            return finalDef;
          }

          if (sanitizedKey === 'maximum_selection') {
            finalDef = {
              ...finalDef,
              max: Number(selectionValue),
              message: `${this.state.selectionText.start} ${selectionValue} ${this.state.selectionText.end}.`,
            };

            return finalDef;
          }

          return finalDef;
        });

        valueTriggered = includes(
          getFieldValue(currentKey),
          get(additional_field, `trigger_${valueKey}`)
        );

        // valueInResponse = includes(defaultValue, get(additional_field, `trigger_${valueKey}`)) && !valueTriggered;

        defaultValue = map(get(responses, currentKey), value => value);

        specialFields = (
          <div>
            {getFieldDecorator(currentKey, {
              rules: rules.length ? ruleDefs : [finalDef],
            })(
              <Checkboxes
                valueKey={valueKey}
                fieldDefs={fields}
                values={options}
                qId={currentKey}
                defaultSelected={defaultValue}
              />
            )}
            <Text type="small" modifiers="error">
              {(getFieldError(currentKey) || []).join(', ')}
            </Text>
            {get(additional_field, 'questions') && valueTriggered
              ? this.processQuestion(
                  get(additional_field, 'questions'),
                  titleKey,
                  valueKey,
                  addRow,
                  newRowValue
                )
              : null}
          </div>
        );
        break;
      case 'radio':
        defaultValue = map(get(responses, currentKey), value => value)[0];

        let radioFields = fields.map((fieldDef, index) =>
          this.mapControlTypes(fieldDef, index, [], defaultValue, titleKey, valueKey)
        );

        valueTriggered =
          lowerCase(getFieldValue(currentKey)) ===
          lowerCase(get(additional_field, `trigger_${valueKey}`));

        valueInResponse =
          lowerCase(defaultValue) === lowerCase(get(additional_field, `trigger_${valueKey}`)) &&
          !valueTriggered;

        mandatoryText = this.state.mandatoryText;

        // setFieldsInitialValue

        specialFields = (
          <div>
            {getFieldDecorator(currentKey, {
              initialValue: defaultValue,
              rules: [
                {
                  required: is_mandatory,
                  message: `${mandatoryText}`,
                },
              ],
            })(<div>{radioFields}</div>)}
            <Text type="small" modifiers="error">
              {(getFieldError(currentKey) || []).join(', ')}
            </Text>
            {get(additional_field, 'questions') && (valueTriggered || valueInResponse)
              ? this.processQuestion(
                  get(additional_field, 'questions'),
                  titleKey,
                  valueKey,
                  addRow,
                  newRowValue
                )
              : null}
          </div>
        );
        break;
      case 'date':
        let selectOptions = range(2020, 1959, -1).map(date => {
          const obj = {
            value: date,
            label: date,
          };
          return obj;
        });
        let fieldId = get(find(fields, ['type', 'date']), 'id');

        defaultValue = get(get(responses, currentKey, ''), fieldId, '').toString();

        let fieldKey = `${currentKey}.${fieldId}`;

        mandatoryText = this.state.mandatoryText;

        specialFields = (
          <div>
            {getFieldDecorator(fieldKey, {
              rules: [
                {
                  required: is_mandatory,
                  message: `${mandatoryText}`,
                },
              ],
            })(<SelectItem response={defaultValue} items={selectOptions} />)}
            <Text type="small" modifiers="error">
              {(getFieldError(fieldKey) || []).join(', ')}
            </Text>
          </div>
        );
        break;
      case 'authorisation_body_list':
        let fieldID = get(find(fields, ['data_source', 'authorisation_body_list']), 'id');
        let fieldKeys = `${currentKey}.${fieldID}`;
        defaultValue = get(get(responses, currentKey, ''), fieldID, '').toString();

        specialFields = (
          <div>
            {getFieldDecorator(
              fieldKeys,
              {}
            )(<AutosuggestInput response={defaultValue} data_source={'authorisation_body_list'} />)}
          </div>
        );
        break;
      case 'donor_list':
        let field_ID = get(find(fields, ['data_source', 'donor_list']), 'id');
        let field_Keys = `${currentKey}.${fieldID}`;
        defaultValue = get(get(responses, currentKey, ''), field_ID, '').toString();

        specialFields = (
          <div>
            {getFieldDecorator(
              field_Keys,
              {}
            )(<AutosuggestInput response={defaultValue} data_source={'donor_list'} />)}
          </div>
        );
        break;
      case 'extended_date':
        let dateOptions = range(2020, 1959, -1).map(date => {
          const obj = {
            value: date,
            label: date,
          };
          return obj;
        });

        let FieldId = get(find(fields, ['type', 'extended_date']), 'id');

        defaultValue = get(get(responses, currentKey, ''), FieldId, '').toString();

        let key = `${currentKey}.${FieldId}`;

        mandatoryText = this.state.mandatoryText;

        specialFields = (
          <div>
            {getFieldDecorator(key, {
              rules: [
                {
                  required: is_mandatory,
                  message: `${mandatoryText}`,
                },
              ],
            })(<SelectItem response={defaultValue} items={dateOptions} />)}
            <Text type="small" modifiers="error">
              {(getFieldError(key) || []).join(', ')}
            </Text>
          </div>
        );
        break;
      case 'table':
        let table = fields[0];

        let tableColumns = get(table, 'columns', []);

        defaultValue = get(responses, currentKey, []);

        let tableRows = get(
          table,
          'rows',
          defaultValue.length <= newRowValue ? newRowValue : defaultValue.length
        );

        let rowCount = range(0, tableRows, 1);

        let inputRows = rowCount.map((row, rowNumber) => {
          let columns = tableColumns.map((fieldDef, columnNumber) => {
            let inputKey = `${currentKey}[${rowNumber}].${get(fieldDef, 'id')}`;

            let columnValue =
              (defaultValue.length && get(defaultValue[rowNumber], get(fieldDef, 'id'), '')) || '';

            mandatoryText = this.state.mandatoryText;
            return (
              <td key={inputKey} className={inputKey}>
                {getFieldDecorator(inputKey, {
                  rules: [
                    {
                      required: is_mandatory,
                      message: `${mandatoryText}`,
                    },
                  ],
                })(
                  this.mapControlTypes(
                    fieldDef,
                    columnNumber,
                    [],
                    columnValue,
                    titleKey,
                    valueKey,
                    inputKey
                  )
                )}
                <Text type="small" modifiers="error">
                  {(getFieldError(inputKey) || []).join(', ')}
                </Text>
              </td>
            );
          });

          return <tr key={rowNumber}>{columns}</tr>;
        });

        let baseWidth = 250;

        let headers = tableColumns.map((column, i) => {
          return (
            <th style={{ width: `${baseWidth}px` }} key={i}>
              {get(column, titleKey, '')}
            </th>
          );
        });

        specialFields = (
          <div>
            <div className="table-wrapper">
              <table
                style={{ width: `${baseWidth * headers.length}px`, marginBottom: '4em' }}
                className="table">
                <thead>
                  <tr>{headers}</tr>
                </thead>
                <tbody>{inputRows}</tbody>
              </table>
            </div>
            {headers.length > 3 ? (
              <Text type="small">
                <i>{this.state.scrollMessage}</i>
              </Text>
            ) : null}

            <Button
              nature="primary"
              modifiers="field-action-button"
              onClick={() => addRow(tableRows)}
              type="button">
              <Text type="small">{this.state.addBtn}</Text>
            </Button>
          </div>
        );
        break;
      default:
        let normalFields = fields.map((fieldDef, index) => {
          let fieldKey = `${currentKey}.${get(fieldDef, 'id')}`;

          let errorMessages = getFieldError(fieldKey) || [];

          defaultValue =
            get(get(responses, currentKey, ''), get(fieldDef, 'id')) ||
            get(responses, currentKey, '');

          mandatoryText = this.state.mandatoryText;
          valueTriggered =
            lowerCase(getFieldValue(currentKey)) ===
            lowerCase(get(additional_field, `trigger_${valueKey}`));

          valueInResponse =
            lowerCase(defaultValue) === lowerCase(get(additional_field, `trigger_${valueKey}`)) &&
            !valueTriggered;

          let field = (
            <div key={index}>
              {getFieldDecorator(fieldKey, {
                initialValue: defaultValue,
                rules: [
                  {
                    required: is_mandatory,
                    message: `${mandatoryText}`,
                  },
                ],
              })(this.mapControlTypes(fieldDef, index, [], defaultValue, titleKey, valueKey))}
              <Text type="small" modifiers="error">
                {errorMessages['join'] && errorMessages.join(', ')}
              </Text>
              {get(additional_field, 'questions') && (valueTriggered || valueInResponse)
                ? this.processQuestion(
                    get(additional_field, 'questions'),
                    titleKey,
                    valueKey,
                    addRow,
                    newRowValue
                  )
                : null}
            </div>
          );

          return field;
        });

        specialFields = <div>{normalFields}</div>;
        break;
    }

    return <div className="question-list__item__question-inputs">{specialFields}</div>;
  }
}

export default FieldProcessor;



// WEBPACK FOOTER //
// ./src/components/BaseQuestionnaire/FieldProcessor.js